var _style, _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _defs3, _clipPath3, _path3, _defs4, _clipPath4, _path4, _defs5, _clipPath5, _path5, _defs6, _clipPath6, _path6, _defs7, _clipPath7, _path7, _defs8, _clipPath8, _path8, _defs9, _clipPath9, _path9, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUoN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 212.6 70",
    width: 2500,
    height: 823,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{clip-path:url(#SVGID_2_);fill:#003a65}.st1{clip-path:url(#SVGID_4_)}.st2,.st3,.st4{clip-path:url(#SVGID_6_);fill:#003a65}.st3,.st4{clip-path:url(#SVGID_8_)}.st4{clip-path:url(#SVGID_10_)}.st5,.st6,.st7{clip-path:url(#SVGID_12_);fill:#003a65}.st6,.st7{clip-path:url(#SVGID_14_)}.st7{clip-path:url(#SVGID_16_)}.st10,.st8,.st9{clip-path:url(#SVGID_18_);fill:#003a65}.st10,.st9{clip-path:url(#SVGID_20_)}.st10{clip-path:url(#SVGID_22_)}.st11,.st12,.st13{clip-path:url(#SVGID_24_);fill:#003a65}.st12,.st13{clip-path:url(#SVGID_26_)}.st13{clip-path:url(#SVGID_28_)}.st14,.st15,.st16{clip-path:url(#SVGID_30_);fill:#003a65}.st15,.st16{clip-path:url(#SVGID_32_)}.st16{clip-path:url(#SVGID_34_)}.st17,.st18,.st19{clip-path:url(#SVGID_36_);fill:#003a65}.st18,.st19{clip-path:url(#SVGID_38_)}.st19{clip-path:url(#SVGID_40_)}.st20,.st21{clip-path:url(#SVGID_42_);fill:#fff}.st21{clip-path:url(#SVGID_44_)}.st22{clip-path:url(#SVGID_46_);fill:#003a65}.st23{clip-path:url(#SVGID_48_);fill:#d91a35}.st24,.st25,.st26{clip-path:url(#SVGID_50_);fill:#d91a35}.st25,.st26{clip-path:url(#SVGID_52_)}.st26{clip-path:url(#SVGID_54_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4 23.2c-5 0-8.3-3.6-8.3-8.8 0-5.2 3.5-8.9 8.5-8.9 4.7 0 7.7 3.4 7.7 9v.7H91.1c0 2.9 1.3 4.5 3.5 4.5 1.6 0 2.7-.9 3.2-2.5l4.5.4c-1.1 3.5-4 5.6-7.9 5.6m3.1-10.8c0-2.5-1.2-3.8-3.2-3.8-1.8 0-3 1.3-3.2 3.8h6.4z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.7 23.2c-5 0-8.2-3.6-8.2-8.8 0-5.2 3.5-8.9 8.5-8.9 4.7 0 7.7 3.4 7.7 9v.7h-11.2c0 2.9 1.3 4.5 3.5 4.5 1.6 0 2.7-.9 3.2-2.5l4.5.4c-1.2 3.5-4.1 5.6-8 5.6m3.1-10.8c0-2.5-1.2-3.8-3.2-3.8-1.8 0-3 1.3-3.2 3.8h6.4z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.8 5.9h5.3l2.4 9.9 2.3-9.9h4.4l2.4 10 2.9-10h4l-4.9 16.8h-4.4l-2.8-10.9-2.7 10.9h-4.1"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.3 8.8c-2.1 0-3.6 1.8-3.6 5.4-.1 3.6 1.4 5.5 3.5 5.5 1.6 0 3.1-1.2 3.4-3.4l4.2.5c-.5 3.9-3.6 6.4-7.9 6.4-5 0-8.4-3.6-8.3-8.8.1-5.4 3.7-8.9 9-8.9 4 0 6.8 2.4 7.3 6.4l-4.3.5c-.4-2.3-1.8-3.6-3.3-3.6"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.1 20c-1.1 2-2.9 3.1-5.3 3.1-3.5 0-5.6-2-5.6-5.1 0-4 3.6-6.1 10.8-6.1v-.7c0-1.7-.9-2.6-2.7-2.6-2 0-3.1.8-3.3 2.4l-4.3-.5c.7-3.3 3.4-5 7.9-5 5 0 7 2 7 6.6v7.5c0 1.4.1 2.5.5 3.2h-4.6c-.3-.9-.4-1.8-.4-2.8m-6-2.3c0 1.4.9 2.2 2.4 2.2 1.9 0 3.4-1.6 3.4-3.9v-1.5c-3.8 0-5.8 1.2-5.8 3.2z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.3 17.4c.4 1.5 1.8 2.4 3.9 2.4 1.8 0 2.8-.8 2.8-1.8 0-1.5-1.4-1.4-3.9-1.9-4-.8-6-2.2-6-5.2 0-3.1 2.5-5.5 6.8-5.5 3.4 0 5.8 1.5 6.8 4.4l-3.8.7c-.6-1.3-1.6-1.9-3.2-1.9s-2.4.6-2.4 1.7c0 1.5 1.6 1.4 4.6 2.1 3.6.8 5.4 2.1 5.4 5 0 3.3-2.8 5.7-7.5 5.7-3.8 0-6.6-1.9-7.4-5.1"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M189.5 0h4.8v22.7h-4.8z"
  })), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.4 36.4c.7-1.2 1.5-2 2.5-2.6.9-.6 2-.9 3.2-.9 1 0 1.9.2 2.6.6.7.4 1.2 1.1 1.7 1.9.4.9.6 1.9.6 3V46c0 .6.1 1 .4 1.2.3.2.7.4 1.3.4h1.1v1.2h-8.2v-1.2h.8c.7 0 1.2-.1 1.5-.4.3-.2.4-.6.4-1v-6.7c0-1.4-.2-2.5-.7-3.2-.6-1-1.5-1.5-2.8-1.5-1.2 0-2.3.5-3.1 1.5-.8 1-1.2 2.3-1.2 3.9V46c0 .6.1 1 .4 1.2.3.2.7.4 1.3.4h1.1v1.2H86v-1.2h1.1c.5 0 .9-.1 1.2-.3.3-.2.4-.5.4-.8V36.3c0-.7-.2-1.2-.5-1.5-.4-.3-.9-.5-1.5-.5h-.8v-1.1l5.5-.3"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M0 0h212.6v70H0z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.9 33.3l6.3-.2v13.5c0 .4.1.6.3.8.3.2.6.3 1 .3h1.8v1.2h-8.9v-1.2h1.7c.5 0 .8-.1 1.1-.4.2-.2.3-.6.3-1v-9.8c0-.6-.2-1.1-.5-1.4-.4-.3-.9-.5-1.6-.5h-1.3m4.2-7.9c.5 0 .9.2 1.3.6.4.4.6.8.6 1.3s-.2.9-.5 1.3c-.4.4-.8.6-1.3.6s-1-.2-1.3-.6c-.4-.4-.6-.8-.6-1.3s.2-.9.6-1.3c.3-.4.7-.6 1.2-.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M174.1 33.3l6.3-.2v13.5c0 .4.1.6.3.8.3.2.6.3 1 .3h1.8v1.2h-8.9v-1.2h1.7c.5 0 .8-.1 1.1-.4.2-.2.3-.6.3-1v-9.8c0-.6-.2-1.1-.5-1.4-.4-.3-.9-.5-1.6-.5h-1.3m4.2-7.9c.5 0 .9.2 1.3.6.4.4.6.8.6 1.3s-.2.9-.6 1.3c-.4.4-.8.6-1.3.6s-1-.2-1.3-.6c-.4-.4-.6-.8-.6-1.3s.2-.9.6-1.3c.3-.4.8-.6 1.3-.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.1 33.2h7.7v1.2c-1 0-1.7.1-2 .3-.3.2-.4.4-.4.7 0 .2.1.5.1.7l4.1 9.3 3.8-9c.1-.2.1-.3.1-.5 0-.8-.8-1.3-2.4-1.5v-1.2h6.5v1.2c-.7.1-1.2.2-1.6.5-.4.3-.7.7-.9 1.2l-5.7 13.3h-.9l-6.1-13.7c-.2-.5-.5-.8-.8-1-.3-.2-.8-.3-1.5-.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M144.5 41.1h-11.3c.1 2.4.5 4.1 1.4 5.1 1 1.1 2.2 1.7 3.7 1.7 2.2 0 4-1.2 5.3-3.7l1.1.5c-1.6 3.2-4 4.7-7.1 4.7-2.1 0-3.9-.8-5.3-2.3-1.4-1.5-2.1-3.5-2.1-5.8 0-2.5.7-4.6 2.1-6.2 1.4-1.6 3.1-2.4 5.2-2.4 1.5 0 2.8.4 3.9 1.2 1.1.8 1.9 1.9 2.5 3.4.3 1 .5 2.3.6 3.8M133.2 40h6.9c.4 0 .7-.1.9-.4.2-.3.3-.7.3-1.4 0-1.2-.4-2.3-1.2-3.1-.8-.9-1.7-1.3-2.7-1.3-1.2 0-2.2.5-3 1.6-.7.9-1.2 2.5-1.2 4.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.1 43.1c.7 1.9 1.5 3.3 2.4 4s2 1.1 3.3 1.1c1.2 0 2.1-.3 2.8-.8.6-.5 1-1.2 1-2 0-.5-.1-.9-.4-1.2-.2-.4-.6-.6-1-.8-.4-.2-1.5-.4-3.3-.8-1.7-.3-2.9-.7-3.5-1.1-.7-.4-1.2-.9-1.6-1.5-.4-.6-.6-1.4-.6-2.1 0-1.1.4-2.2 1.1-3.1 1-1.2 2.4-1.8 4.1-1.8 1.4 0 2.6.4 3.8 1.3l1.1-1.2h.7l.4 5.6h-1.1c-.5-1.6-1.2-2.8-2-3.5-.8-.7-1.9-1.1-3.1-1.1-1.1 0-1.9.3-2.5.8-.6.5-.9 1.2-.9 1.9s.3 1.2.8 1.7 1.6.8 3.2 1.1c1.9.3 3.1.6 3.6.8.9.3 1.6.8 2.1 1.5s.7 1.5.7 2.5c0 1.4-.5 2.5-1.6 3.5s-2.5 1.4-4.1 1.4c-1.5 0-3-.5-4.3-1.5l-1.2 1.4h-.9l-.3-6.2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M194.9 33.2h7.5v1.2h-.7c-.7 0-1.1.1-1.3.3-.2.2-.4.4-.4.7 0 .1 0 .3.1.4l4.4 9.4 3.3-7.8c.2-.6.4-1.1.4-1.6 0-.4-.2-.7-.5-1-.3-.2-1-.4-1.9-.4v-1.2h6.5v1.2c-1.2.1-2.1.7-2.5 1.7l-5.9 13.5c-1 2.3-2 3.9-3 4.7-1 .9-2.1 1.3-3.2 1.3-.8 0-1.5-.2-2-.7-.5-.5-.8-1-.8-1.7 0-.5.2-.9.5-1.2.3-.3.7-.5 1.2-.5.4 0 .8.1 1.1.4.3.3.4.6.4 1 0 .1 0 .3-.1.5 0 .2-.1.3-.1.4 0 .3.2.4.5.4.4 0 .8-.1 1.2-.4.5-.3.9-.7 1.3-1.3.4-.6 1.1-1.9 2.1-3.9l-5.9-12.7c-.2-.4-.5-.8-.8-1-.3-.2-.8-.4-1.4-.4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.6 0h6.1l8.6 14V0h4.8v22.7H79L69.4 6.9v15.8h-4.8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M61.7 26.1H72v1.2h-1.7c-.6 0-1 .1-1.3.3-.2.2-.4.5-.4.9V41c0 1.5.1 2.6.4 3.3.4 1.1 1.1 2 2.1 2.6 1 .7 2.3 1 3.9 1 2.2 0 3.9-.6 5.1-1.7 1.2-1.2 1.8-2.7 1.8-4.7v-9.8c0-1-.1-1.8-.2-2.3-.1-.5-.3-.9-.6-1.2-.3-.3-.6-.5-1-.6-.4-.1-1.1-.2-2-.2v-1.2h9.4v1.2h-.7c-1 0-1.8.3-2.3.8-.5.6-.8 1.4-.8 2.5v10.6c0 2.7-.8 4.7-2.3 6.1-1.7 1.6-4 2.4-6.8 2.4-2.4 0-4.4-.3-5.8-1-1.4-.7-2.4-1.7-3.1-3-.5-1-.7-2.2-.7-3.7V28.6c0-.4-.1-.7-.4-.9-.3-.2-.7-.3-1.2-.3h-1.8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M187.3 19.2c-.5.1-1 .2-1.5.2-1.7 0-2-.8-2-2.7V9.2h3.5V5.9h-3.5V1l-4.8.9v4h-2.2v3.3h2.2v8.1c0 4.1 1.6 5.9 5.5 5.9.9 0 1.8-.1 2.8-.3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M193.8 42.9c-.1 1.6-.4 2.8-.9 3.5-.5.7-1.2 1.1-1.9 1.1-.6 0-1.2-.2-1.6-.7-.4-.5-.6-1.2-.6-2V34.6h4.9v-1.4h-4.9v-6.5h-1.1c-.1 2.2-.6 3.9-1.6 5.1-.7.8-1.6 1.4-2.9 1.6v1.2h2.8v10.7c0 1.2.4 2.1 1.1 2.8.7.7 1.8 1.1 3.1 1.1 1.4 0 2.6-.5 3.5-1.5.9-1 1.4-2.6 1.4-4.7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M157 32.6c-2.7 0-5 3.2-6 6.8v-6.5l-5.7.3v1.2h1.4c.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v10c0 .3-.1.5-.4.7-.3.2-.7.3-1.2.3h-1.6v1.2h9.8v-1.2h-2c-.6 0-1.1-.1-1.4-.3-.3-.2-.4-.5-.4-.9v-2.9c0-3 1.3-8.1 3.8-8.1.7 0 .6 1.1 1.9 1.1 1.1 0 1.9-.8 1.9-1.9.1-1.2-.9-2-2-2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M0 0v22.7C0 56.1 29.8 70 29.8 70s29.8-13.9 29.8-47.3V0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1 1h57.8v21.7H1z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M49 44.8c0-1.9-.3-3.8-.8-5.5-5.2 3.4-10.4 4.3-13.4 2.5.2-.2.3-.5.3-.8 0-.7-.6-1.3-1.3-1.3-.3 0-.6.1-.8.3-1.9-3.1-1-8.2 2.4-13.4-1.8-.5-3.7-.8-5.5-.8s-3.7.3-5.5.8c3.4 5.2 4.3 10.4 2.4 13.4-.2-.2-.5-.3-.8-.3-.7 0-1.3.6-1.3 1.3 0 .3.1.6.3.8-3.1 1.9-8.2 1-13.4-2.5-.5 1.8-.8 3.7-.8 5.5 0 1.9.3 3.8.8 5.5C16.8 46.9 22 46 25 47.8c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3.3 0 .6-.1.8-.3 1.9 3.1 1 8.2-2.4 13.4 1.8.5 3.7.8 5.5.8 1.9 0 3.7-.3 5.5-.8-3.4-5.1-4.3-10.3-2.4-13.3.2.2.5.3.8.3.7 0 1.3-.6 1.3-1.3 0-.3-.1-.6-.3-.8 3.1-1.9 8.2-1 13.4 2.5.5-1.9.8-3.7.8-5.6"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M33.3 44.8c0 1.9-1.5 3.5-3.5 3.5-1.9 0-3.5-1.6-3.5-3.5s1.5-3.5 3.5-3.5 3.5 1.6 3.5 3.5"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M11.6 14.3c-1.5-1.1-3.3-1.1-3.7-1.1.4-.7.6-.8 1.3-1.2-2.3 0-2.6-.6-2.7-1.2.6.1 1.3-.1 1.6-.4-1.7-.1-2.2-1.2-2.4-1.6C7 8.8 7 8.1 6.8 7.7c-.1-.3-.6-.6-1-.4-.4.1-.8.6-1.2.7-.3 0-.4-.4-.4-.6-.4 0-.8.2-1.1.5.1-1.5 1.7-2.1 2.7-1.9 0 0 0-.6-.3-.8-.3-.3-.7-.3-1-.5 0-.3 0-.6.3-.7-.3-.5-1.2-.5-1.2-.5 1.8-1.3 3 .4 3.4 1.7.5-.6.5-.9.5-1.3-.1-.4-.4-.6-.4-.8 0-.3.4-.2.4-.2 0-.5-.4-.9-.8-1 0 0 1.5-.1 2 1.4.5 1.4-.2 2.3-.2 2.3s.5.1.8-.2c.2-.3.1-.7.4-.9.3-.5.6 0 .6 0 .3-.3.1-.9 0-1.1 0 0 .8.5.7 1.4-.1.6-.7 1.1-.9 1.4-.2.3-1 1 .2 3.1.7 1.3 1.4 1.8 1.8 1.9-.3.4-.7 1.7-.5 3.1"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M5.8 17c-1.4.1-3.9.7-2.6 3.3 0-.6.2-1.1.5-1.3.1.4.4.5.6.3.2-.1.5-.6.7-.8.2-.2.6-.3 1-.1-1.2 1.9.2 3.8 1.2 3.7-.6-.4-.6-1-.6-1.2 0 0 .4.1.5-.2.1-.2-.1-.7.1-1.2.1-.3.4-.4.6-.4.4.1.5.4.5.7 0 .4-.2.7-.2.7.6.5 2.3-.1 3.4-1 0 .3 0 .8-.3 1.2.9.2 2.5-.8 3-1.7.1.4 0 1.3-.5 1.8.7.2 2.6-.4 4.1-1.9.1.8 1.3 2 2.7 1.4 0 0-.6-.4-.6-.8 0-.8.9-1.4 2-1.9 1.3-.6 3.4-.8 5.5-1.8 3.9-1.9 4.6-3.6 7.8-3.6 1.4 0 2.8.3 3.5 1.5.7 1.2.5 2.5 1.3 3.3.8.8 2.2.2 2.9 0 1.9-.6 4.6-1.7 6.3-1.8 1.7-.1 2.1 1.1 2.1 1.2.1.4 0 .6-.3.6-.6 0-1.6-.3-2.2 0-.8.5-.6 1.6-.6 1.6.2-.3.7-.9 1.3-.8 0 0 .1.7.6.4.3-.2.7-.6 1.4-.5-.6.6-1.9 2.8-.1 3.7-.3-.4-.3-1.1-.1-1.4 0 0 .5.3.8-.1.1-.2-.1-.7.1-1.2.1-.4.5-.6.5-.6.1.5 1 1.9 3.3 1.8-.5-.2-.8-.6-.9-.8.3-.2.4-.6.1-.7-.3-.1-.8 0-1-.4-.3-.4-.2-1-.2-1 .8.3 2.7 1.1 3.5-.6-.2.2-.9.4-1.3.3 0-.2-.3-.8-.7-.8-.5 0-.9.1-1.4.2-.4 0-.6-.1-.7-.3-.1-.2 0-.4.1-.5.2-.3.6-.4.6-.4-.3-.6-1.3-.3-1.5-.3 0-.3.4-.9 1-1.2-.2-.4-1-.8-2.2-.6.1-.5.6-1 .9-1.2-.6-.4-2.2-.2-3.5.8.1-.3 0-1.2-.4-1.6 0 0-1.8 2.2-3.5 2-1.8-.3-1.5-2.4-1.5-2.4s3.5.5 5.1-.2c1.7-.8 1.7-2 3.1-2.7 1.1-.6 2.4-.1 2.4-.1-.2-1.2-2.4-2.1-4.1-.3 0 0 0-2.7-4.2-2.5-1.5.1-4.3.9-6.9 1.4-2.5.5-6.2.7-7.8.7-1.6 0-3.1-.3-3.1-1.4s1.1-1.2 1.9-1.2c1.2 0 2.9.7 4.2 1.2 1 .3 1.9.3 2.4.3 1.4 0 3.2-.7 4.1-1.1 1-.3 1.7-.5 3.5-.4-.5-.7-2.5-1.5-4.8-.3-.2-.4.2-1.1 1.1-1.3-.4-.3-1.7-.6-3.3-.6-2.5.1-3.3 1.2-5.7 1.1-2.4-.1-4.6.3-4.6 2.1 0 1.4 1.8 2.6 4.6 2.7-.1.2-.5.5-.6.6 1 .2 2.4 0 4.3-1.2 0 .2-.1.7-.3.9.7 0 1.9-.3 3.4-1.3 0 .2 0 .6-.4.9 1.8-.1 2.7-1 3.9-1.4 1.6-.5 6.7-1.7 6.7 1.2 0 .7-.3 1.7-2.1 1.7s-4.8-.8-5.4-.9c-.6-.1-1.2-.2-2.8 0-1.4.2-12.3 1.8-14.1 2 0 .6 0 2.4 1 3.2-.8.4-1.6.6-3 0-.1.5 0 1.8.7 2.6-.6.2-1.7.5-2.8-.2-.4.8-1.6 2.9-4.8 2.3.2-.2.8-1.3.8-1.5-.6.5-2.3 1.4-5.4 1-.9-.1-1.9-.4-2.2-1-.3-.6.1-1.6-.1-2.1-.4-1.1-1.6-1-1.6-1 .1.1.6.4.6.8 0 0-.5 0-.5.5 0 .7.2 1.5.2 1.5-1.3-1.3-3.5-2.7-4.2-.4.3-.3.6-.5 1-.5 0 0-.3.4.3.8.2.2.8 0 1.1.1.5 0 .8.6.8.6"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M34.7 16.4c.3.2.1.4 0 .5-.1.1-1.6 1.1-2.5.8-.7-.2-.7-1.5-1.7-1.9-.8-.3-1.7.3-1.7.3.3 0 .8.2.9.2 0 0-.2.3.1.4.3.2.5.1.7.3.3.3 0 .9 0 .9-2.1-1.7-4.1-.5-4.2.5.2-.1.7-.4 1-.3 0 0 0 .3.3.4.3.1.7-.2 1.1-.1.5.1.9.5.9.5-.7.1-2.1 1.2-1 2.9 0-.3 0-.7.2-.8 0 0 .4.2.6 0 .2-.2.3-.7.6-1.1.3-.4.7-.4.7-.4-.2.9.7 2.8 2.2 2.4-.3-.2-.6-.6-.6-.8 0 0 .4-.2.4-.4-.1-.4-.7-.3-.7-.8 0-.3.3-.5.7-.5.9 0 .8 1.2.8 1.2.6-.1 1.5-.8 1.7-1.5.3.2.5 1 .4 1.5.8-.3 1.4-.9 1.4-3 .6.9 2.2 1.4 3.4.6-1.5-.2-1.8-1.8-1.9-2.1-.1-.3-.2-1.5-.9-2.2-1-1-3.2-.9-4.5-.5-.3.1-.7.3-.7 1 0 .6.1 1.2 1 1.6.8.1 1.1.3 1.3.4"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    d: "M0 0h212.6v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M25.4 5.6c0-.1.1-.4-.2-.5-.5-.1-1.5 0-1.5 0 .5-.5.3-1.9-.3-2.3-.1.6-.7 1-1.2.8-.7-.2-.4-1.2-.2-1.6-.5 0-1.5.1-2.2 1.2-.2-1.4-1.6-1.7-2-1.7.2.6-.2 1.5-.7 1.4-.1-1-1.1-1.4-1.1-.7-.1 1.1-1.1 2.4-2 2.5-.1.6.6.9 1 .9-1 1.5-2.5 1.2-3.3.9 0 .6.6 1.8 1.8 1.8-.6.9-1.9 1-2.3.8-.2.9 1.3 1.7 1.7 1.8-1.2 1.9-.8 4.2-.1 5.2 0 0 .3-.7.6-1 .3-.3.5-.4.7-.2.3.1.2.6 0 .9-.3.6-.9 1.2-.9 1.2 1.1.3 3.1-.9 3.3-1.4.2.6-.2 1.6-.5 2.1 2.1.2 3.2-1.6 3.6-2.7.7.8 1.6.9 2.1.8-.7-1.3-.4-2.6-.1-3.1.7.7 1.8.8 2.3.7-.7-.9-.7-3.3-.5-4.1.5.3 1.1.4 1.4.2 0 0-.4-.8-.3-2 .2-.9.6-1.5.9-1.9m-8.2.6c.1-.1.2-.2.3-.1.1.2.2.4.5.6.1.2.4.3.5.3.1.3-.4.7-1.1.1-.3-.3-.4-.7-.2-.9zm1.6 5.8c-.3.5-1.3 1.3-2 .9.3-.1 1-.6 1.4-1.3-.1-.1-.3-.2-.4-.3-.2.1-.6.5-1 1 0-.3.2-.9.4-1.3-.2 0-.5-.2-.6-.2-.3.7-.3 1.6-.2 1.9-.6-.3-.7-1.6-.4-2.1-.8-.6-.5-1.2-.3-1.4 0 .2.2.7.9 1 .7.4 1 .1 1 0 .1-.3-.2-.5-.4-.8-.2-.3-.3-.7-.1-.9.2-.3.6-.2.7-.1-.8.2.2 1 .4 1.2.3.1 1.6.4 1.2-.3.2.1.5.3.4.6-.1.2-.4.5-.8.4-.4 0-.8-.2-.9.1-.1.2-.1.5.6.9.7.3 1.2.2 1.4.1 0 .3-.4.9-1.3.6zm2.7-3.6c-.1.3-.4.4-.9.3-.9-.2-.9-.8-.6-.9.1.1.4.3.6.3.4.1.5 0 .8 0 .2 0 .2.2.1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUoN);
export default __webpack_public_path__ + "static/media/UoN.77f4689b956927891867d4613b5d2ad0.svg";
export { ForwardRef as ReactComponent };